module.exports = __webpack_public_path__ + "img/craftBannerSatelliteBroker.5248b09.jpg";